import React from 'react';

const WhySection = () => {
  const features = [
    { icon: '/icon2.png', title: '24+ Years Talent Acquisition' },
    { icon: '/icon1.png', title: '100% Exposure for Freshers' },
    { icon: '/icon1.png', title: '15+ Bollywood Alumni' },
    { icon: '/icon4.png', title: 'No.1 Most Talked Pageant' }
  ];

  return (
    <section className="py-12 md:py-16 text-center bg-white">
      <div className="container mx-auto px-4">
        <h2 className="font-bold text-2xl md:text-3xl mb-8 text-gray-900">
          Why is this the <span className="text-red-600">#1 TEEN Pageant</span> in India?
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mt-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center transform hover:scale-105 transition-all duration-300 p-4 rounded-lg hover:bg-gray-50"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 mb-3 flex items-center justify-center">
                <img 
                  src={feature.icon} 
                  alt={feature.title}
                  className="w-full h-full object-contain"
                />
              </div>
              <h6 className="text-sm md:text-base font-semibold mt-2 px-2 text-gray-800">
                {feature.title}
              </h6>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;